import {
  API_SUCCESS,
  API_FAIL,
  GET_CHARTS_DATA,
  GET_TASK_DATA,
  GET_TASK_DATA_FAIL,
  GET_TASK_DATA_SUCCESS,
  APPROVE_TASK,
  APPROVE_TASK_FAIL,
  APPROVE_TASK_SUCCESS,
  TEAM_DASHBOARD_LIST,
  TEAM_DASHBOARD_LIST_SUCCESS,
  TEAM_DASHBOARD_LIST_FAIL,
  TEAM_ACTION,
  TEAM_ACTION_SUCCESS,
  TEAM_ACTION_FAIL,
  TEAM_SHIFT_START_ACTION,
  TEAM_SHIFT_START_ACTION_SUCCESS,
  TEAM_SHIFT_START_ACTION_FAIL,
  TEAM_SHIFT_END_ACTION,
  TEAM_SHIFT_END_ACTION_SUCCESS,
  TEAM_SHIFT_END_ACTION_FAIL,
  TEAM_TASK_LIST,
  TEAM_TASK_LIST_SUCCESS,
  TEAM_TASK_LIST_FAIL,
} from "./actionTypes";

export const approveTask = data => ({
  type: APPROVE_TASK,
  payload: data,
});

export const approveTaskSuccess = events => ({
  type: APPROVE_TASK_SUCCESS,
  payload: events,
});

export const approveTaskFail = error => ({
  type: APPROVE_TASK_FAIL,
  payload: error,
});

export const apiSuccess = (actionType, data) => ({
  type: API_SUCCESS,
  payload: { actionType, data },
});

export const apiFail = (actionType, error) => ({
  type: API_FAIL,
  payload: { actionType, error },
});

// charts data
export const getChartsData = periodType => ({
  type: GET_CHARTS_DATA,
  payload: periodType,
});

export const getTaskData = data => ({
  type: GET_TASK_DATA,
  payload: data,
});

export const getTaskDataSuccess = events => ({
  type: GET_TASK_DATA_SUCCESS,
  payload: events,
});

export const getTaskDataFail = error => ({
  type: GET_TASK_DATA_FAIL,
  payload: error,
});

export const teamDashboardList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TEAM_DASHBOARD_LIST,
  payload: { data, onSuccess, onError },
});

export const teamDashboardListSuccess = (data = {}) => ({
  type: TEAM_DASHBOARD_LIST_SUCCESS,
  payload: data,
});

export const teamDashboardListFail = (data = {}) => ({
  type: TEAM_DASHBOARD_LIST_FAIL,
  payload: data,
});

export const teamAction = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TEAM_ACTION,
  payload: { data, onSuccess, onError },
});

export const teamActionSuccess = (data = {}) => ({
  type: TEAM_ACTION_SUCCESS,
  payload: data,
});

export const teamActionFail = (data = {}) => ({
  type: TEAM_ACTION_FAIL,
  payload: data,
});

export const teamShiftStartAction = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TEAM_SHIFT_START_ACTION,
  payload: { data, onSuccess, onError },
});

export const teamShiftStartActionSuccess = (data = {}) => ({
  type: TEAM_SHIFT_START_ACTION_SUCCESS,
  payload: data,
});

export const teamShiftStartActionFail = (data = {}) => ({
  type: TEAM_SHIFT_START_ACTION_FAIL,
  payload: data,
});

export const teamShiftEndAction = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TEAM_SHIFT_END_ACTION,
  payload: { data, onSuccess, onError },
});

export const teamShiftEndActionSuccess = (data = {}) => ({
  type: TEAM_SHIFT_END_ACTION_SUCCESS,
  payload: data,
});

export const teamShiftEndActionFail = (data = {}) => ({
  type: TEAM_SHIFT_END_ACTION_FAIL,
  payload: data,
});

export const teamTaskList = (data = {}, onSuccess = () => {}, onError = () => {}) => ({
  type: TEAM_TASK_LIST,
  payload: { data, onSuccess, onError },
});

export const teamTaskListSuccess = (data = {}) => ({
  type: TEAM_TASK_LIST_SUCCESS,
  payload: data,
});

export const teamTaskListFail = (data = {}) => ({
  type: TEAM_TASK_LIST_FAIL,
  payload: data,
});
